import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { SecuritylistMember } from 'SecurityListsApp/ts/interfaces/security-list-member.interface';

import { AjaxService } from 'Angular/services/core/ajax.service';
import { UrlsService } from 'Angular/services/core/urls.service';

import { formFlattenedObject } from 'Angular/utils/urls';

@Injectable({
    providedIn: 'root',
})
export class SecurityListService {
    constructor(private ajaxService: AjaxService, private urlsService: UrlsService) {}

    getLength(
        securitylistName: string,
        securityGroup: string,
        validDetailedSecurityTypes: string[]
    ): Observable<{ length: number }> {
        const getParams = formFlattenedObject({ validDetailedSecurityTypes }, ['validDetailedSecurityTypes']);
        const urlParams = { securitylistName, securityGroup };
        const url = this.urlsService.getUrl(this.urlsService.SECURITY_LISTS.SECURITYLIST_LENGTH, urlParams);
        return this.ajaxService.getDataObserveBody<{ length: number }>(url, getParams);
    }

    getMembers(
        securitylistName: string,
        securityGroup: string,
        validDetailedSecurityTypes: string[]
    ): Observable<SecuritylistMember[]> {
        const getParams = formFlattenedObject({ validDetailedSecurityTypes }, ['validDetailedSecurityTypes']);
        const urlParams = { securitylistName, securityGroup };
        const url = this.urlsService.getUrl(this.urlsService.SECURITY_LISTS.SECURITYLIST_MEMBERS, urlParams);
        return this.ajaxService.getDataObserveBody<SecuritylistMember[]>(url, getParams);
    }
}
